// Collection Tabs
class CollectionTabs {
  /**
   * @param {HTMLElement} container
   */
  constructor(container) {
    this.container = container;
    this.tabNav = container.querySelector('.collection-tabs__nav');
    this.tabContents = container.querySelectorAll('[data-tab-name]');
    this.controller = new AbortController();
    
    this.init();
  }

  init() {
    const { signal } = this.controller;
    console.log('CollectionTabs initialized');
    this.generateTabs();
    this.setupEventListeners(signal);
    this.showFirstTab();
  }

  /**
   * Generate tab buttons from content elements
   */
  generateTabs() {
    this.tabContents.forEach((/** @type {HTMLElement} */ content, /** @type {number} */ index) => {
      const tabName = content.getAttribute('data-tab-name');
      const tabId = content.getAttribute('data-tab-id');
      const contentId = content.getAttribute('id');

      if (!tabName || !tabId || !contentId) return;

              // Create tab button
              const tabButton = document.createElement('button');
              tabButton.className = `collection-tabs__tab${index === 0 ? ' collection-tabs__tab--active' : ''}`;
              tabButton.setAttribute('role', 'tab');
              tabButton.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
              tabButton.setAttribute('aria-controls', contentId);
              tabButton.setAttribute('id', `tab-${tabId}`);
              tabButton.setAttribute('data-tab-id', tabId);
              tabButton.textContent = tabName;

      if (this.tabNav) {
        this.tabNav.appendChild(tabButton);
      }
    });
  }

  /**
   * Setup event listeners for tab interactions
   * @param {AbortSignal} signal - Abort signal for cleanup
   */
  setupEventListeners(signal) {
    if (!this.tabNav) return;
    
    // Handle tab clicks
    this.tabNav.addEventListener('click', (/** @type {Event} */ e) => {
      if (e.target && e.target instanceof HTMLElement && e.target.matches('[role="tab"]')) {
        const tabId = e.target.getAttribute('data-tab-id');
        if (tabId) this.showTab(tabId);
      }
    }, { signal });

    
  }

  /**
   * Show the specified tab and hide others
   * @param {string} targetTabId - The ID of the tab to show
   */
  showTab(targetTabId) {
    // Hide all tab contents
    this.tabContents.forEach((/** @type {HTMLElement} */ content) => {
      content.style.display = 'none';
      content.setAttribute('aria-hidden', 'true');
    });

    

    // Remove active state from all tabs
    const tabs = this.container.querySelectorAll('[role="tab"]');
    tabs.forEach((/** @type {HTMLElement} */ tab) => {
      tab.setAttribute('aria-selected', 'false');
      tab.classList.remove('collection-tabs__tab--active');
    });

    console.log("tabs", tabs)

    // Show target tab content
    const targetContent = this.container.querySelector(`[data-tab-content-id="${targetTabId}"]`);
    console.log("targetContent", targetContent)
    if (targetContent && targetContent instanceof HTMLElement) {
      targetContent.style.display = 'block';
      targetContent.setAttribute('aria-hidden', 'false');
    }

    // Activate target tab
    const targetTab = this.container.querySelector(`[data-tab-id="${targetTabId}"]`);
    console.log("targetTab", targetTab)
    if (targetTab && targetTab instanceof HTMLElement) {
      targetTab.setAttribute('aria-selected', 'true');
      targetTab.classList.add('collection-tabs__tab--active');
    }
  }

  /**
   * Show the first tab by default
   */
  showFirstTab() {
    console.log("out side loop")
    if (this.tabContents.length > 0 && this.tabContents[0]) {

      const firstTabId = this.tabContents[0].getAttribute('data-tab-id');
      console.log("firstTabId", firstTabId)
      if (firstTabId) this.showTab(firstTabId);
    }
  }

  /**
   * Cleanup method to remove event listeners
   */
  destroy() {
    this.controller.abort();
  }
}

// Initialize collection tabs when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const tabContainers = document.querySelectorAll('.collection-tabs');
  
  tabContainers.forEach((/** @type {HTMLElement} */ container) => {
    new CollectionTabs(container);
  });
});

// Export for ES6 modules
export default CollectionTabs;
